// Centralized language metadata for flags and display names

export const languages = [
  { code: 'ja', name: '日本語', flagUrl: 'https://flagcdn.com/w20/jp.png' },
  { code: 'en', name: 'English', flagUrl: 'https://flagcdn.com/w20/us.png' },
];

export const normalizeLang = code => {
  if (!code) return '';
  return String(code).toLowerCase().split('-')[0];
};

export const getLanguage = code => {
  const norm = normalizeLang(code);
  return languages.find(l => l.code === norm) || null;
};

export const getFlagUrl = code => {
  const lang = getLanguage(code);
  return lang ? lang.flagUrl : null;
};

export const getLanguageName = code => {
  const lang = getLanguage(code);
  return lang ? lang.name : String(code || '').toUpperCase();
};
